/* eslint-disable jsx-a11y/anchor-is-valid */
/*
 * File: UserDropdown.tsx
 * Project: receiving-rules
 * -----
 * Last Modified: 01 Oct 2020 8:02:25 pm
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */

import { ProfileOutlined } from '@ant-design/icons';
import { useAuth0 } from '@auth0/auth0-react';
import { Avatar, Dropdown, MenuProps, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useGetUserQuery } from 'redux/services/cookieMonster/cookieMonsterApi';

export enum MenuKeys {
  logout = 'Log Out',
  about = 'About',
  profile = 'Profile',
  releaseNotes = 'Release Notes'
}

export const UserDropdown = (): JSX.Element => {
  const { logout } = useAuth0();
  const navigate = useNavigate();

  const { user } = useAuth0();
  const { data, isLoading, isFetching } = useGetUserQuery(user?.sub as string);

  const handleAboutPage = (): void => {
    navigate(`/about`);
  };
  const versionNumber = process.env.REACT_APP_VERSION_NUMBER as string;

  const items: MenuProps['items'] = [
    {
      label: MenuKeys.about,
      key: 1,
      onClick: handleAboutPage
    },
    {
      label: MenuKeys.releaseNotes,
      key: 2,
      onClick: (): void => navigate(`/release-notes/${versionNumber}`)
    },
    {
      label: (
        <a target="_blank" href={process.env.REACT_APP_PROFILE_URL} rel="noreferrer">
          {MenuKeys.profile}
        </a>
      ),
      key: 3
    },
    {
      label: MenuKeys.logout,
      key: 4,
      onClick: (): void => logout({})
    }
  ];

  return (
    <Dropdown menu={{ items }} trigger={['click']}>
      <Avatar
        icon={isLoading || isFetching ? <Spin size="small" spinning></Spin> : <ProfileOutlined />}
        style={{ cursor: 'pointer' }}
        src={data && data.user_metadata.profile_image_url ? data.user_metadata.profile_image_url : !isLoading || !isFetching ? user?.picture : undefined}
      />
    </Dropdown>
  );
};
